import { u as useTheme } from './useTheme-c05a5bd5.esm.js';
import React__default from 'react';
import { View, StyleSheet } from 'react-native';
import { A as AppText } from './index-48b066c3.esm.js';

const HorizontalSeparator = _ref => {
  let {
    text,
    separatorContainer
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const styles = generateStyles(currentTheme);
  return /*#__PURE__*/React__default.createElement(View, {
    style: [styles.separatorContainer, separatorContainer]
  }, /*#__PURE__*/React__default.createElement(View, {
    style: styles.line
  }), /*#__PURE__*/React__default.createElement(View, {
    style: styles.textContainer
  }, /*#__PURE__*/React__default.createElement(AppText, {
    style: styles.text
  }, text)), /*#__PURE__*/React__default.createElement(View, {
    style: styles.line
  }));
};
const generateStyles = currentTheme => StyleSheet.create({
  separatorContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginTop: 20 // Adjust for space around the separator
  },
  line: {
    flex: 1,
    height: 1,
    // Adjust thickness of the line
    backgroundColor: currentTheme?.theme?.lightGrey,
    width: 150 // Adjust line color
  },
  textContainer: {
    paddingHorizontal: 10 // Adjust for space on the sides of the text
  },
  text: {
    fontSize: 14,
    color: currentTheme?.theme?.mediumGrey
  }
});
HorizontalSeparator.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "HorizontalSeparator"
};

export { HorizontalSeparator as H };
